import { render, staticRenderFns } from "./SentenceTemplateEditor.vue?vue&type=template&id=23cc4abd&"
import script from "./SentenceTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./SentenceTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./SentenceTemplateEditor.vue?vue&type=style&index=0&id=23cc4abd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports